// extracted by mini-css-extract-plugin
module.exports = {"fallWickets":"style_fallWickets__MrcoZ","head":"style_head__Fqbtu","content":"style_content__ggGPw"};